export const isVrsConfigMismatch = (offer, vinResults, cadsUsed) => {
  const misMatchedOptions =
    !cadsUsed && offer && offer.prospect.options && vinResults && vinResults.options
      ? vinResults.options.filter(({ optionId: id1 }) => !offer.prospect.options.some(({ optionId: id2 }) => id2 === id1)).concat(offer.prospect.options.filter(({ optionId: id1 }) => !vinResults.options.some(({ optionId: id2 }) => id2 === id1)))
      : []
  return misMatchedOptions.length !== 0
}
